module.exports = __webpack_public_path__ + "img/IMG_0079_L_Wood.10f5d0eb.jpg";